import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import DashboardFlightsCardTable from 'components/DashboardFlightsCardTable';

import { DashboardFlightsCardUpdateStatus_flightsInfo$key } from '__generated__/DashboardFlightsCardUpdateStatus_flightsInfo.graphql';
import { DashboardFlightsCardUpdateStatus_settings$key } from '__generated__/DashboardFlightsCardUpdateStatus_settings.graphql';

type Props = {
  flightsInfo: DashboardFlightsCardUpdateStatus_flightsInfo$key;
  settings: DashboardFlightsCardUpdateStatus_settings$key;
};

const DashboardFlightsCardUpdateStatus: FC<Props> = props => {
  const flightsInfo = useFragment(
    graphql`
      fragment DashboardFlightsCardUpdateStatus_flightsInfo on DashboardFlightsInfo {
        totalFailed

        ...DashboardFlightsCardTable_flightsInfo
      }
    `,
    props.flightsInfo
  );

  const { flightsUpdaterEnabled } = useFragment(
    graphql`
      fragment DashboardFlightsCardUpdateStatus_settings on Settings {
        flightsUpdaterEnabled
      }
    `,
    props.settings
  );

  const { totalFailed } = flightsInfo;

  if (!flightsUpdaterEnabled) {
    return (
      <Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flexGrow: 1 }}>Skrydžių atnaujinimas išjungtas</Box>

          <ErrorOutlineIcon
            fontSize="small"
            color="error"
            sx={{
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          />
        </Box>

        <Typography variant="caption" color="text.secondary">
          Įjungti Bendri nustatymai &gt; Skrydžiai skiltyje
        </Typography>
      </Box>
    );
  }

  return totalFailed > 0 ? (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Link href={'/flights?isUpdating=0&expired=0'}>
            Neatnaujinami skrydžiai
          </Link>
        </Box>

        <Box>
          <ErrorOutlineIcon
            fontSize="small"
            color="error"
            sx={{
              display: 'inline-block',
              verticalAlign: 'middle',
              mr: 1,
            }}
          />
          <Link href={'/flights?isUpdating=0&expired=0'}>{totalFailed}</Link>
        </Box>
      </Box>

      <DashboardFlightsCardTable flightsInfo={flightsInfo} />
    </Box>
  ) : (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ flexGrow: 1 }}>Visi skrydžiai atnaujinti sėkmingai</Box>

      <CheckCircleIcon
        fontSize="small"
        color="success"
        sx={{
          display: 'inline-block',
          verticalAlign: 'middle',
        }}
      />
    </Box>
  );
};

export default DashboardFlightsCardUpdateStatus;
